import { gql } from '@apollo/client';

export const BlogInfoFragment = gql`
  fragment BlogInfo on RootQuery {
    generalSettings {
      title
      description
    }
  }
`;
